<div class="dialog-overlay" (click)="$event.stopPropagation()">
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="dialog-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"></path>
        </svg>
      </div>
      <h2 class="dialog-title">New Version Available</h2>
    </div>
    
    <div class="dialog-content">
      <p class="dialog-message">
        A new version of the application is available. Please refresh to get the latest updates and improvements.
      </p>
    </div>
    
    <div class="dialog-actions">
      <button class="dialog-button primary" (click)="onRefreshClick()">
        Refresh
      </button>
    </div>
  </div>
</div>
